import React from 'react';

import Dropdown from '../../../../ui/Dropdown/Dropdown';
import type { MedicationSelectorDropdownProps } from '../../types/MedicationSelectorDropdownProps';
import { TRANSLATION_CLASS_NAMES } from '../../../../utils/element-ids';

const renderMedicationValue = (value: string) => {
  if (value === '') {
    return (
      <span
        className={
          TRANSLATION_CLASS_NAMES.TRANSLATION_CLASS_NAME
        }
      >
        Select medication
      </span>
    );
  }
  return value;
};

const MedicationSelectorDropdown: React.FC<
  MedicationSelectorDropdownProps
> = ({ id, onChange, value, options, errorMessage, onBlur }) => {
  return (
    <Dropdown
      value={value}
      testid={id}
      isUsedByChildSession
      options={options}
      errorMessage={errorMessage}
      inputLabel="Medication name"
      onChange={onChange}
      onBlur={onBlur}
      renderValue={renderMedicationValue}
    />
  );
};

export default MedicationSelectorDropdown;